if (!customElements.get("variant-ottoman-opening")) {
  customElements.define(
    "variant-ottoman-opening",
    class VariantOttomanOpening extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.section = this.closest("section");
        this.selectedOpening = this.querySelector("[data-ottoman-opening-choice]:checked")?.value || "";
        this.addEventListener("change", (event) => {
          if (!event.target.matches("[data-ottoman-opening-choice]")) return;
          this.selectedOpening = event.target.value;
          this.clearError();
        });
        this.section?.addEventListener("variantChangeEnd", (event) => {
          const picker = event.target.closest("variant-options") || event.target;
          const variantId = picker.currentVariant?.id || picker.dataset.variantId;
          if (variantId) this.updateForVariant(String(variantId));
        });
        this.section?.addEventListener("variantProductInfoRendered", (event) => {
          const variantId = event.detail?.variant?.id;
          if (variantId) this.updateForVariant(String(variantId));
        });
        this.updateForVariant(String(this.dataset.selectedVariantId || ""));
      }

      updateForVariant(variantId) {
        let visibleGroup = null;
        this.querySelectorAll("[data-ottoman-opening-for]").forEach((group) => {
          const show = group.dataset.ottomanOpeningFor === variantId;
          group.hidden = !show;
          group.querySelectorAll("[data-ottoman-opening-choice]").forEach((input) => {
            input.disabled = !show;
            input.checked = show && input.value === this.selectedOpening;
          });
          if (show) visibleGroup = group;
        });
        this.hidden = !visibleGroup;
        this.clearError();
      }

      validateSelection() {
        const group = this.querySelector("[data-ottoman-opening-for]:not([hidden])");
        if (!group) return true;
        const selected = group.querySelector("[data-ottoman-opening-choice]:checked");
        if (selected) return true;

        const error = group.querySelector("[data-ottoman-opening-error]");
        if (error) error.hidden = false;
        group.querySelector("[data-ottoman-opening-choice]")?.focus();
        return false;
      }

      applySelection(form) {
        const selected = this.querySelector('[data-ottoman-opening-for]:not([hidden]) [data-ottoman-opening-choice]:checked');
        let property = form.querySelector('[data-ottoman-opening-property]');
        if (!property) {
          property = document.createElement("input");
          property.type = "hidden";
          property.name = "properties[Ottoman opening side]";
          property.dataset.ottomanOpeningProperty = "";
          form.appendChild(property);
        }
        property.value = selected?.value || "";
        property.disabled = !selected;
      }

      clearError() {
        this.querySelectorAll("[data-ottoman-opening-error]").forEach((error) => {
          error.hidden = true;
        });
      }
    }
  );
}
